/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BulkUnfavoriteRequest,
  BulkUnfavoriteResponse,
  FavoritePro,
  FavoriteProRequest,
  FavoriteProsListParams,
  PaginatedFavoriteProListList
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getFavoriteProsListUrl = (params: FavoriteProsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/favorite-pros/?${stringifiedParams}` : `/api/favorite-pros/`
}

/**
 * List a location's favorited pros.
 *
 * `location_id` is required. Access is authorized per-location the same way the
 * favorite/unfavorite mutations are: gigpro admins see any location, everyone else
 * only locations they actively manage.
 */
export const favoriteProsList = async (params: FavoriteProsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedFavoriteProListList> => {

  return customFetch<PaginatedFavoriteProListList>(getFavoriteProsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFavoriteProsListInfiniteQueryKey = (params?: FavoriteProsListParams,) => {
    return [
    'infinite', `/api/favorite-pros/`, ...(params ? [params] : [])
    ] as const;
    }

export const getFavoriteProsListQueryKey = (params?: FavoriteProsListParams,) => {
    return [
    `/api/favorite-pros/`, ...(params ? [params] : [])
    ] as const;
    }


export const getFavoriteProsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof favoriteProsList>>, FavoriteProsListParams['page']>, TError = void>(params: FavoriteProsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof favoriteProsList>>, TError, TData, QueryKey, FavoriteProsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFavoriteProsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof favoriteProsList>>, QueryKey, FavoriteProsListParams['page']> = ({ signal, pageParam }) => favoriteProsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof favoriteProsList>>, TError, TData, QueryKey, FavoriteProsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FavoriteProsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof favoriteProsList>>>
export type FavoriteProsListInfiniteQueryError = void


export function useFavoriteProsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof favoriteProsList>>, FavoriteProsListParams['page']>, TError = void>(
 params: FavoriteProsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof favoriteProsList>>, TError, TData, QueryKey, FavoriteProsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof favoriteProsList>>,
          TError,
          Awaited<ReturnType<typeof favoriteProsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFavoriteProsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof favoriteProsList>>, FavoriteProsListParams['page']>, TError = void>(
 params: FavoriteProsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof favoriteProsList>>, TError, TData, QueryKey, FavoriteProsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof favoriteProsList>>,
          TError,
          Awaited<ReturnType<typeof favoriteProsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFavoriteProsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof favoriteProsList>>, FavoriteProsListParams['page']>, TError = void>(
 params: FavoriteProsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof favoriteProsList>>, TError, TData, QueryKey, FavoriteProsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useFavoriteProsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof favoriteProsList>>, FavoriteProsListParams['page']>, TError = void>(
 params: FavoriteProsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof favoriteProsList>>, TError, TData, QueryKey, FavoriteProsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFavoriteProsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getFavoriteProsListQueryOptions = <TData = Awaited<ReturnType<typeof favoriteProsList>>, TError = void>(params: FavoriteProsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof favoriteProsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFavoriteProsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof favoriteProsList>>> = ({ signal }) => favoriteProsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof favoriteProsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FavoriteProsListQueryResult = NonNullable<Awaited<ReturnType<typeof favoriteProsList>>>
export type FavoriteProsListQueryError = void


export function useFavoriteProsList<TData = Awaited<ReturnType<typeof favoriteProsList>>, TError = void>(
 params: FavoriteProsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof favoriteProsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof favoriteProsList>>,
          TError,
          Awaited<ReturnType<typeof favoriteProsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFavoriteProsList<TData = Awaited<ReturnType<typeof favoriteProsList>>, TError = void>(
 params: FavoriteProsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof favoriteProsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof favoriteProsList>>,
          TError,
          Awaited<ReturnType<typeof favoriteProsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFavoriteProsList<TData = Awaited<ReturnType<typeof favoriteProsList>>, TError = void>(
 params: FavoriteProsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof favoriteProsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useFavoriteProsList<TData = Awaited<ReturnType<typeof favoriteProsList>>, TError = void>(
 params: FavoriteProsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof favoriteProsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFavoriteProsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getFavoriteProsCreateUrl = () => {




  return `/api/favorite-pros/`
}

/**
 * Allows managers to favorite or unfavorite pros.
 *
 * Favorited pros receive priority in the matching algorithm when new gigs
 * are posted at that location.
 */
export const favoriteProsCreate = async (favoriteProRequest: FavoriteProRequest, options?: Parameters<typeof customFetch>[1]): Promise<FavoritePro | FavoritePro[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<FavoritePro | FavoritePro[]>(getFavoriteProsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(favoriteProRequest)
  }
);}





export const getFavoriteProsCreateMutationKey = () => ['favoriteProsCreate'] as const;

export const getFavoriteProsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof favoriteProsCreate>>, TError,FavoriteProsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof favoriteProsCreate>>, TError,FavoriteProsCreateMutationVariables, TContext> => {

const mutationKey = getFavoriteProsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof favoriteProsCreate>>, FavoriteProsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  favoriteProsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FavoriteProsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof favoriteProsCreate>>>
    export type FavoriteProsCreateMutationBody = FavoriteProRequest
    export type FavoriteProsCreateMutationError = void
    export type FavoriteProsCreateMutationVariables = {data: FavoriteProRequest}

    export const useFavoriteProsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof favoriteProsCreate>>, TError,FavoriteProsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof favoriteProsCreate>>,
        TError,
        FavoriteProsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getFavoriteProsCreateMutationOptions(options), queryClient);
    }
    export const getFavoriteProsDestroyUrl = (id: number,) => {




  return `/api/favorite-pros/${id}/`
}

/**
 * Allows managers to favorite or unfavorite pros.
 *
 * Favorited pros receive priority in the matching algorithm when new gigs
 * are posted at that location.
 */
export const favoriteProsDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getFavoriteProsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getFavoriteProsDestroyMutationKey = () => ['favoriteProsDestroy'] as const;

export const getFavoriteProsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof favoriteProsDestroy>>, TError,FavoriteProsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof favoriteProsDestroy>>, TError,FavoriteProsDestroyMutationVariables, TContext> => {

const mutationKey = getFavoriteProsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof favoriteProsDestroy>>, FavoriteProsDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  favoriteProsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FavoriteProsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof favoriteProsDestroy>>>

    export type FavoriteProsDestroyMutationError = void
    export type FavoriteProsDestroyMutationVariables = {id: number}

    export const useFavoriteProsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof favoriteProsDestroy>>, TError,FavoriteProsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof favoriteProsDestroy>>,
        TError,
        FavoriteProsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getFavoriteProsDestroyMutationOptions(options), queryClient);
    }
    export const getFavoriteProsBulkUnfavoriteCreateUrl = () => {




  return `/api/favorite-pros/bulk-unfavorite/`
}

/**
 * Remove a pro from favorites at multiple locations in a single request.
 */
export const favoriteProsBulkUnfavoriteCreate = async (bulkUnfavoriteRequest: BulkUnfavoriteRequest, options?: Parameters<typeof customFetch>[1]): Promise<BulkUnfavoriteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BulkUnfavoriteResponse>(getFavoriteProsBulkUnfavoriteCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkUnfavoriteRequest)
  }
);}





export const getFavoriteProsBulkUnfavoriteCreateMutationKey = () => ['favoriteProsBulkUnfavoriteCreate'] as const;

export const getFavoriteProsBulkUnfavoriteCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof favoriteProsBulkUnfavoriteCreate>>, TError,FavoriteProsBulkUnfavoriteCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof favoriteProsBulkUnfavoriteCreate>>, TError,FavoriteProsBulkUnfavoriteCreateMutationVariables, TContext> => {

const mutationKey = getFavoriteProsBulkUnfavoriteCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof favoriteProsBulkUnfavoriteCreate>>, FavoriteProsBulkUnfavoriteCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  favoriteProsBulkUnfavoriteCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FavoriteProsBulkUnfavoriteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof favoriteProsBulkUnfavoriteCreate>>>
    export type FavoriteProsBulkUnfavoriteCreateMutationBody = BulkUnfavoriteRequest
    export type FavoriteProsBulkUnfavoriteCreateMutationError = void
    export type FavoriteProsBulkUnfavoriteCreateMutationVariables = {data: BulkUnfavoriteRequest}

    export const useFavoriteProsBulkUnfavoriteCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof favoriteProsBulkUnfavoriteCreate>>, TError,FavoriteProsBulkUnfavoriteCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof favoriteProsBulkUnfavoriteCreate>>,
        TError,
        FavoriteProsBulkUnfavoriteCreateMutationVariables,
        TContext
      > => {
      return useMutation(getFavoriteProsBulkUnfavoriteCreateMutationOptions(options), queryClient);
    }
